import React from 'react';
import { TextField, TextFieldVariants } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FieldRenderProps } from 'react-final-form';

type TextInputProps = FieldRenderProps<number, HTMLElement, string> & {
  isEditable?: boolean; // Nueva prop para manejar el modo de edición
  variant?: TextFieldVariants;
};

const TextInput: React.FC<TextInputProps> = ({
  input: { value, onChange, onBlur, ...inputProps },
  meta: { touched, error },
  ignoreError = false,
  isEditable = true,
  displayValue,
  variant = 'outlined',
  ...props
}) => {
  const { t: translate } = useTranslation();

  if (!isEditable) {
    // Modo display (solo muestra el valor)
    return <p>{displayValue || value}</p>;
  }

  // Modo editable
  return (
    <TextField
      {...inputProps}
      value={value}
      onChange={(event) => {
        onChange(event);
        if (props.onFieldChange) props.onFieldChange(event.target.value);
        if (props.onTextFieldChange) props.onTextFieldChange(event);
      }}
      onBlur={onBlur}
      error={!!(touched && error && !ignoreError)}
      helperText={touched && error && !ignoreError && translate(error)}
      fullWidth
      variant={variant}
      {...props}
    />
  );
};

TextInput.displayName = 'TextInput';

export default TextInput;
